import { PointsProps } from './types/types';

export const getPointId = (point: PointsProps) => {
  return `${point.address}-${point.entry.name.toLowerCase().replace(/ /g, '-')}`;
};
